<div class="fixed-footer">
	<div class="container">
		<div *ngIf="loading" class="loading-spinner"></div>

		<!--  FINANCE MODE  -->

		<div
			*ngIf="!cashback_deal && finance_meta.enabled && finance_meta.available && stacked_quotes.length > 0"
			class="finance-footer"
			[ngClass]="{ loading: loading }"
		>
			<div class="row">
				<div
					class="col-xxs-13 align-center"
					[class.col-xxs-30]="!selected_quote?.regular_payment"
					[class.col-sm-30]="!selected_quote?.regular_payment"
				>
					<div class="value-container">
						<span class="value text-hl">{{ deposit | money }}</span>
						<span class="label">TOTAL DEPOSIT</span>
						<i
							class="icon-info icon-button text-hl"
							[tooltip]="'Show Deposit Breakdown'"
							data-element-click="info_icon__engage_configure_fixed_footer__[Show Deposit Breakdown]"
							(click)="onShowDepositBreakdown('deposit')"
						></i>
					</div>
				</div>

				<div *ngIf="selected_quote?.regular_payment" class="col-xxs-4 align-center plus">+</div>

				<div *ngIf="selected_quote?.regular_payment" class="col-xxs-13 align-center">
					<div class="value-container">
						<span class="value text-hl">
							{{ selected_quote.regular_payment | money : 2 }}
							<small>P/M</small>
						</span>
						<span class="label">For {{ selected_quote.number_of_regular_payments | pluralise : 'month' : '+s' }}</span>
						<i
							class="icon-info icon-button text-hl"
							[tooltip]="'Show Finance Breakdown'"
							data-element-click="info_icon__engage_configure_fixed_footer__[Show Finance Breakdown]"
							(click)="onShowDepositBreakdown('finance')"
						></i>
					</div>
				</div>
			</div>
		</div>

		<!--  END FINANCE MODE  -->

		<!--  CASHBACK DEAL MODE  -->

		<div *ngIf="cashback_deal" class="cash-footer">
			<div class="label">Total owed from dealer:</div>
			<div class="value text-hl">{{ -grand_total | money : 2 }}</div>
		</div>

		<!--  END CASHBACK DEAL MODE  -->

		<!--  CASH MODE  -->

		<div
			*ngIf="!(finance_meta.enabled && finance_meta.available && stacked_quotes.length > 0) && !cashback_deal"
			class="cash-footer"
			[ngClass]="{ loading: loading }"
		>
			<div class="label">Total to pay:</div>
			<div class="value text-hl">
				{{ (vehicle.add_vat ? grand_total_net : grand_total) | money : 2 }}
				<small *ngIf="vehicle.add_vat">+ {{ grand_total_vat | money : 2 }} VAT</small>
				<small *ngIf="part_exchanges !== null && part_exchanges.length > 0">+ P/EX</small>
			</div>
		</div>

		<!--  END CASH MODE  -->
	</div>
</div>
